import Container from "@vfuk/core-container";

import classes from "./NoResultsRow.module.scss";

type NoResultsRowProps = {
  text: string;
};

export const NoResultsRow = ({ text }: NoResultsRowProps): JSX.Element => {
  return (
    <Container elevation paddingLevel={2}>
      <div className={classes.NoResults}>{text}</div>
    </Container>
  );
};
